import React, { useState } from "react";
import getHelpText from 'fantastic/lib/helpText';
import Video from './items/Video'
import HelpItem from './items/HelpItem'


const General = () => {
  const helpText = getHelpText();
  const [isModalOpen, toggleModal] = useState(false)

  const showVideo = () => {
    toggleModal(true)
  }

  const closeVideo = (e) => {
    toggleModal(false)
  }

  const renderWatchVideo = () => {
    if(i18n.locale !== 'ru') return null;

    return (
      <div className="play-again" onClick={showVideo}>
        <div className="icon">
          <i className="fa fa-play"></i>
        </div>
        { i18n.t('watch_video') }
      </div>
    );
  };

  if (isModalOpen) return <Video closeVideo={closeVideo}/>

  return (
    <>
      <div className="introduction">
        <div> { helpText.introduction } </div>
        { renderWatchVideo() }
      </div>

      {
        helpText.general.map((item, key) => {
          return <HelpItem key={key} item={item}/>
        })
      }
    </>
  )
}

export default General
